import { TabData } from '@ddt-web/data-service';
import * as cloneDeep from 'lodash/cloneDeep';
import * as get from 'lodash/get';

export class ColumnChartUtil {
	public static getCombinedTabDataForColumnChart(data: TabData[]): TabData {
		const cellsData = get(data[0], 'tableData[0].cells', []).map((row, index) => {
			return data.map(tabData => {
				return get(tabData, `tableData[0].cells[${index}][0]`);
			});
		}
		);
		const chartData = cloneDeep(data[0]);
		if (chartData) {
			chartData.tableData[0].cells = cellsData;
		}
		return chartData;
	}

	/**
	 * Only for use in highcharts config
	 */
	public static yAxisLabelPercentageFormatter = function (): string {
		return this.value + '%';
	};
}
